import { type IApiResponse, type IGeoZoneByIDStates, type IGeoZoneStates } from '@/helpers/types';
import { getCommandQuery, type IGetQuery } from '@/store/actions/api-utils';

import { coreApiSlice } from '../apiSlice';

const geozoneApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		createGeographicalZone: builder.mutation<IApiResponse, { name: string; code: string; zoneId: number }>({
			query: (body) => ({
				url: '/GeographicalZone',
				method: 'POST',
				body,
			}),
		}),
		getGeographicalZone: builder.query<IGeoZoneStates, IGetQuery>({
			query: ({ paged, query }) => ({
				url: `/GeographicalZone${getCommandQuery(paged, ...(query || []))}`,
			}),
		}),
		getGeographicalZoneById: builder.query<IGeoZoneByIDStates, { id: string }>({
			query: ({ id }) => ({
				url: `/GeographicalZone/${id}`,
			}),
		}),
		getGeographicalZoneByName: builder.mutation<IApiResponse, { name: string }>({
			query: ({ name }) => ({
				url: `/GeographicalZone/name?name=${name}`,
				method: 'POST',
			}),
		}),
		updateGeographicalZone: builder.mutation<IApiResponse, { id: number; name?: string; code?: string; zoneId?: number }>({
			query: (body) => ({
				method: 'PUT',
				url: '/GeographicalZone/update',
				body,
			}),
		}),
		deleteGeographicalZone: builder.mutation<IApiResponse, { id: number }>({
			query: ({ id }) => ({
				url: `/GeographicalZone/delete/${id}`,
				method: 'DELETE',
			}),
		}),
	}),
});

export const {
	useCreateGeographicalZoneMutation,
	useDeleteGeographicalZoneMutation,
	useGetGeographicalZoneByIdQuery,
	useLazyGetGeographicalZoneByIdQuery,
	useGetGeographicalZoneByNameMutation,
	useGetGeographicalZoneQuery,
	useLazyGetGeographicalZoneQuery,
	useUpdateGeographicalZoneMutation,
} = geozoneApiSlice;
